import PropTypes from 'prop-types';
import React from 'react';
import { SOCIAL_MEDIA_SHARE_LINKS } from '../../config/links/links';
import SocialMediaShareButton from './SocialMediaShareButton';

const SocialMediaShareButtons = ({ site }) => {
  const buttons = SOCIAL_MEDIA_SHARE_LINKS[site];

  return (
    <>
      <div className="share-buttons">
        {buttons.map((button, index) => (
          <SocialMediaShareButton
            ariaLabel={button.ariaLabel}
            backgroundColor={button.backgroundColor}
            href={button.href}
            icon={button.icon}
            key={index}
          />
        ))}
      </div>
      <style jsx>{`
        .share-buttons {
          display: flex;
          align-items: center;
        }
      `}</style>
    </>
  );
};

SocialMediaShareButtons.propTypes = {
  site: PropTypes.string.isRequired,
};

export default SocialMediaShareButtons;
